import apiClient from "./axios.config";

const vendorForgot = {
  forgotPassword: async (phoneNo) => {
    try {
      const response = await apiClient.post("/vendor/forgot-password", {
        phoneNo,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default vendorForgot;
